import { rules, type schema } from "@/utils/validators";
import type { institutionFormData } from "./types.props";

export const institutionSchema: schema<institutionFormData> = {
    name: [
        rules.required("El nombre de la institución es requerido."),
        rules.minLength(3, "El nombre debe tener al menos 3 caracteres."),
    ],
};
